export default __webpack_public_path__ + "static/media/Arm Band of the Amaranthine Drums.15322f3b.jpg";